import { get, put } from '../api';
import type { ProjectsFilter } from '../../../shared/projectsV2/filters';
import type { TeamSelection } from '../../types';

export const ADD_TEAM_PROJECTS = 'ADD_TEAM_PROJECTS';
export const SET_TEAM_USER_ROLE = 'SET_TEAM_USER_ROLE';

export const FETCH_ALL_TEAMS = 'FETCH_ALL_TEAMS';
export const SET_TEAM_SELECTION = 'SET_TEAM_SELECTION';

const teamActions = {
  fetchAll: (filters?: object) => ({
    type: FETCH_ALL_TEAMS,
    async payload() {
      return get(`/api/teams`, true, filters);
    },
  }),
  addTeamProjects: (teamId: number | string, projectIds: string[] | 'all', filters?: ProjectsFilter) => ({
    type: ADD_TEAM_PROJECTS,
    async payload() {
      return put(`/api/teams/${teamId}/projects`, { projects: projectIds, action: 'add', filters });
    },
  }),
  setTeamUserRole: (payload: { teamId: number; userId: number; roleId: number }) => ({
    type: SET_TEAM_USER_ROLE,
    payload,
  }),
  setTeamSelection: (selection: TeamSelection) => ({
    type: SET_TEAM_SELECTION,
    payload: selection,
  }),
};

export default teamActions;
